<template>
    <page>
        <module title="储值送活动详情">
            <div v-if="activityInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="活动名称">{{ activityInfo.activity_name }}</c-detail-item>
                    <c-detail-item label="活动日期">{{ activityInfo.begin_date }} - {{ activityInfo.end_date}}</c-detail-item>
                    <c-detail-item label="充值金额">￥{{ parseFloat(activityInfo.recharge_amount).toFixed(2) }}</c-detail-item>
                    <c-detail-item label="状态">
                        <span v-if="activityInfo.start_state == 0" style="color:#999">{{activityStateText[activityInfo.start_state]}}</span>
                        <span v-if="activityInfo.start_state == 1" style="color:dodgerblue">{{activityStateText[activityInfo.start_state]}}</span>
                        <span v-if="activityInfo.start_state == 2" style="color:#999">{{activityStateText[activityInfo.start_state]}}</span>
                        <span v-if="activityInfo.start_state == 3" style="color:red">{{activityStateText[activityInfo.start_state]}}</span>
                    </c-detail-item>
                    <c-detail-item label="创建时间">{{ activityInfo.create_date }}</c-detail-item>
                    <c-detail-item label="更新时间">{{ activityInfo.update_date }}</c-detail-item>
                    <c-detail-item label="可售范围">{{activityInfo.visible_user_level_name}}</c-detail-item>
                </c-detail>

                <c-detail title="免费穿商品（以下商品任选一件）">
                    <c-table v-model="productList" height="auto" border>
                        <c-table-column label="商品信息" name="productName" width="250">
                            <template v-slot="{data}">
                                <product-info
                                        :image="data.productImgUrl"
                                        :name="`${data.productName}`">
                                </product-info>
                            </template>
                        </c-table-column>
                        <c-table-column label="商品价格" name="productPrice" width="100">
                            <template v-slot="{data}">￥{{ data.productPrice }}</template>
                        </c-table-column>
                    </c-table>
                </c-detail>
            </div>
            <template slot="button">
                <c-button size="m" @click="closeCurrPage()">关闭</c-button>
            </template>
        </module>
    </page>
</template>

<script>
import productInfo from '@/components/public/product_info.vue';

export default {
    name: 'recharge_bonus_detail',

    components: {
        productInfo
    },

    props: {
        id: String
    },

    data() {
        return {
            activityInfo: {},
            productList: [],
            stateOptions: [
                { name: '未开始', value: 0 },
                { name: '进行中', value: 1 },
                { name: '已结束', value: 2 },
                { name: '暂停中', value: 3 }
            ],
        };
    },

    watch: {
        id() {
            this.getDetail();
        }
    },

    mounted() {
        this.getDetail();
    },

    computed: {
        activityStateText() {
            var state = {};
            this.stateOptions.forEach(item => {
                state[item.value] = item.name;
            });

            return state;
        }
    },

    methods: {
        getDetail() {
            this.request({
                url: '/recharge_bonus/detail',
                data: { id: this.id },
                loading: true,
                success: data => {
                    console.log(data)
                    this.activityInfo = data;
                    this.productList = data.product_list.map(item => {
                        return {
                            productName: item.product_name,
                            productPrice: item.product_price,
                            productImgUrl: item.product_img_url
                        };
                    });
                }
            });
        },
        closeCurrPage() {
            this.redirectTo('/recharge_bonus');
        }
    }
};
</script>
